import { Component, OnInit } from '@angular/core';
import { MLSListingService } from 'src/services/mls-listings.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {

  constructor(private mlsService:MLSListingService) { }

  
  listings : any;

  ngOnInit() {
    this.listings = this.mlsService.getSavedSearchResults()
    // console.log(this.listings);
  }


  getPrice(x) {
    var price = parseInt(x);
    var final_price = '$' + this.numberWithCommas(price);
    return final_price;
  }


  numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getListingPageID(listing_id) {
    var link = '/listing/' + listing_id;
    return link;
  }

}
